import style from './style';
import TimelineLink from '../timelineLink/TimelineLink';
import ReturnButton from '../returnButton/ReturnButton';
import Clock from '../clock/Clock';
import Glitch from '../glitch/Glitch';

const Timeline = props => {
    const {site} = props;
    const boolRand = () => { return Math.random() > 0.6 ? true : false; };
    const blockedInYourCountry = 'Извините, данный контент недоступен в вашей стране';
    return (

        <div id={'timeline'} class={`${style['timeline']} ${style['timeline--' + site]}`}>
            {
                props.site === 1 &&
                <>
                    <div className={`${style['timeline__episode-name']} ${style['timeline__episode-name--' + site]}`}>
                        ХОЛИВАР
                    </div>
                    <TimelineLink site={site} video={'episode-1-seksa-u-nas-net'}><p
                        class={`${style['timeline__outstanding--' + site]}`}>

                        &nbsp;###
                        ### &nbsp;##### &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
                        <br/>
                        &nbsp;### ###
                        ## &nbsp; ## &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        <br/>
                        &nbsp;&nbsp;# &nbsp; # &nbsp;## &nbsp; &nbsp; &nbsp; ##### &nbsp;## &nbsp; ## &nbsp;##### &nbsp; #### &nbsp; &nbsp; &nbsp;## &nbsp; ## &nbsp; &nbsp;## &nbsp; ## &nbsp;#### &nbsp; &nbsp;##### &nbsp; &nbsp; ## &nbsp; ## &nbsp;##### &nbsp;###### &nbsp; &nbsp; &nbsp; &nbsp; ## &nbsp; ## &nbsp; &nbsp;## &nbsp; ##
                        ## &nbsp; ##&nbsp;<br/>
                        &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; ## &nbsp; &nbsp; &nbsp;## &nbsp; ##
                        ## &nbsp;## &nbsp;## &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;## &nbsp; &nbsp; ## &nbsp; ## &nbsp; &nbsp;## &nbsp; ## &nbsp; &nbsp; ## &nbsp;## &nbsp; &nbsp; &nbsp; &nbsp; ## &nbsp; ##
                        ## &nbsp; ## &nbsp; ## &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ## &nbsp;### &nbsp; &nbsp;### ###
                        ## &nbsp; ##&nbsp;<br/>
                        &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; ## &nbsp; &nbsp; &nbsp;###### &nbsp;##### &nbsp; ## &nbsp; &nbsp; &nbsp; ##### &nbsp; &nbsp; ## &nbsp; ## &nbsp; &nbsp;####### &nbsp;##### &nbsp;## &nbsp; &nbsp; &nbsp; &nbsp; #######
                        ###### &nbsp; &nbsp;## &nbsp; &nbsp;### &nbsp; &nbsp;## # ## &nbsp; &nbsp;## # ##
                        #### &nbsp;#&nbsp;<br/>
                        &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; ## &nbsp; ##
                        ## &nbsp; &nbsp; &nbsp;## &nbsp;## &nbsp;## &nbsp; &nbsp; &nbsp;## &nbsp;## &nbsp; &nbsp; &nbsp;###### &nbsp; &nbsp;## &nbsp; ##
                        ## &nbsp;## &nbsp;## &nbsp; &nbsp; &nbsp; &nbsp; ## &nbsp; ##
                        ## &nbsp; &nbsp; &nbsp; &nbsp;## &nbsp; &nbsp;### &nbsp; &nbsp;### &nbsp;## &nbsp; &nbsp;## &nbsp; ##
                        ## &nbsp;# #&nbsp;<br/>
                        &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;##### &nbsp; ##### &nbsp;## &nbsp; ## &nbsp;##### &nbsp; ###### &nbsp; &nbsp; &nbsp; &nbsp; ## &nbsp; &nbsp;## &nbsp; ## &nbsp;###### &nbsp;##### &nbsp; &nbsp; ## &nbsp; ## &nbsp;##### &nbsp; &nbsp;## &nbsp; &nbsp; # &nbsp; &nbsp; ## &nbsp; ## &nbsp; &nbsp;## &nbsp; ##
                        #### &nbsp;#&nbsp;<br/>
                        &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ##### &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;# &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        <br/>
                        &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ###
                        ###&nbsp;<br/>
                        &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ###
                        ###&nbsp;<br/>
                        &nbsp;## &nbsp; ## &nbsp;#### &nbsp; ###### &nbsp; ##### &nbsp; ##### &nbsp; ##### &nbsp;###### &nbsp;## &nbsp; ##
                        ## &nbsp; ## &nbsp;##### &nbsp; ##### &nbsp;## &nbsp; ##
                        ## &nbsp; ## &nbsp; &nbsp;###### &nbsp;###### &nbsp; ##### &nbsp;###### &nbsp;## &nbsp; ##
                        ##### &nbsp; &nbsp; &nbsp;###### &nbsp;###### &nbsp; ##### &nbsp; ##### &nbsp; ##### &nbsp; # &nbsp; # &nbsp;
                        <br/>
                        &nbsp;## &nbsp;## &nbsp; &nbsp; &nbsp;## &nbsp; &nbsp;## &nbsp; &nbsp;## &nbsp; ## &nbsp; &nbsp; &nbsp;##
                        ## &nbsp; ## ## &nbsp; ## ## &nbsp;### ## &nbsp; ## ## &nbsp; ##
                        ## &nbsp; &nbsp; &nbsp;## &nbsp;## &nbsp;## &nbsp;### &nbsp; &nbsp;## &nbsp; ## ## &nbsp; ##
                        ## &nbsp; ## &nbsp; ## &nbsp; &nbsp;## &nbsp;###
                        ## &nbsp;## &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;## &nbsp; ## &nbsp; &nbsp;## &nbsp; ## &nbsp; &nbsp; &nbsp;##
                        ## &nbsp; ## &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<br/>
                        &nbsp;##### &nbsp; &nbsp;##### &nbsp; &nbsp;## &nbsp; &nbsp;###### &nbsp; ##### &nbsp;## &nbsp; ##
                        ###### &nbsp;## # ## &nbsp;###### ###### &nbsp;## &nbsp; &nbsp; &nbsp;##### &nbsp; ## #
                        ## &nbsp; &nbsp;## &nbsp; ## ###### &nbsp;## &nbsp; ## &nbsp; ## &nbsp; &nbsp;## # ##
                        ###### &nbsp; &nbsp; &nbsp; ##### &nbsp; ## &nbsp; &nbsp;## &nbsp; ## &nbsp;##### &nbsp;## &nbsp; ## &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
                        <br/>
                        &nbsp;## &nbsp;## &nbsp;## &nbsp;## &nbsp; &nbsp;## &nbsp; &nbsp;## &nbsp; &nbsp; &nbsp;## &nbsp; &nbsp; &nbsp;## &nbsp; ##
                        ## &nbsp; &nbsp; &nbsp;### &nbsp;## &nbsp; &nbsp; &nbsp;##
                        ## &nbsp; &nbsp; &nbsp;## &nbsp; &nbsp; &nbsp;## &nbsp;## &nbsp;### &nbsp;## &nbsp; &nbsp;## &nbsp; ##
                        ## &nbsp; &nbsp; &nbsp;## &nbsp; ## &nbsp; ## &nbsp; &nbsp;### &nbsp;##
                        ## &nbsp; ## &nbsp; &nbsp; &nbsp; &nbsp; ## &nbsp; ## &nbsp; &nbsp;## &nbsp; ##
                        ## &nbsp; &nbsp; &nbsp;## &nbsp; ## &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;<br/>
                        &nbsp;## &nbsp; ## &nbsp;###### &nbsp; ## &nbsp; &nbsp; ##### &nbsp; ###### &nbsp;##### &nbsp;## &nbsp; &nbsp; &nbsp;## &nbsp; ## &nbsp; &nbsp; &nbsp;## &nbsp;##### &nbsp; ##### &nbsp;## &nbsp; ##
                        ## &nbsp; ## &nbsp; &nbsp;## &nbsp; ##
                        ## &nbsp; &nbsp; &nbsp; ##### &nbsp; &nbsp;## &nbsp; &nbsp;## &nbsp; ##
                        ###### &nbsp; &nbsp; ###### &nbsp; &nbsp;## &nbsp; &nbsp; ##### &nbsp; ###### &nbsp;##### &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        <br/>
                        &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
                        <br/>


                    </p>
                    </TimelineLink>
                    <span class={`${style['timeline__year--' + site]}`}>
                        1982</span>
                    <p class={`${style['timeline__date--' + site]}`}>
                        5 сентября: <TimelineLink site={site} content="episode-1-shatz">Джоэл
                        Шац</TimelineLink> и <TimelineLink site={site}
                                                           content="episode-1-goldin">Иосиф
                        Гольдин</TimelineLink> проводят первый
                        телемост СССР – США</p>
                    <p class={`${style['timeline__date--' + site]}`}>
                        В Институте атомной энергии им. И.В. Курчатова начали создавать советскую версию
                        операционной системы UNIX "Демос"</p>
                    <span class={`${style['timeline__year--' + site]}`}>
                        1988</span>
                    <p class={`${style['timeline__date--' + site]}`}>Создателям "Демоса" вручают награды в Кремле</p>
                    <span class={`${style['timeline__year--' + site]}`}>
                        1990</span>
                    <p class={`${style['timeline__date--' + site]}`}>
                        Основана компания "СовАм телепорт" – первая телекоммуникационная система в СССР</p>
                    <p class={`${style['timeline__date--' + site]}`}>
                        Создана российская компьютерная сеть "Релком"</p>
                    <p class={`${style['timeline__date--' + site]}`}>
                        28 августа: зарегистрирован первый домен для Советского Союза – .su</p>
                    <span className={`${style['timeline__year--' + site]}`}>
                        1991</span>
                    <p class={`${style['timeline__date--' + site]}`}>
                        Путч, через сеть "Релком" в условиях блокады СМИ было распространено обращение Бориса Ельцина и
                        репортажи о ситуации в Москве</p>
                    <span class={`${style['timeline__year--' + site]}`}>
                        1994</span>
                    <p class={`${style['timeline__date--' + site]}`}>
                        В России начинают делать web</p>
                    <TimelineLink site={site} video={'episode-1-dve-devushki-v-chas'}>
                        <p className={`${style['timeline__outstanding--' + site]}`}>
                            <br/>
                            &nbsp;###
                            ### &nbsp; #### &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ###
                            ###&nbsp;<br/>
                            &nbsp;### ### &nbsp;##
                            ## &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; #### &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;###
                            ###&nbsp;<br/>
                            &nbsp;&nbsp;# &nbsp; # &nbsp; ##
                            ## &nbsp;##### &nbsp; &nbsp;##### &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;## &nbsp;##### &nbsp;##### &nbsp; ## &nbsp; ##
                            ## # ## ## &nbsp; ##
                            ## &nbsp; ## &nbsp; &nbsp;##### &nbsp; &nbsp; &nbsp;## &nbsp; ## &nbsp;#### &nbsp; &nbsp;##### &nbsp; # &nbsp; # &nbsp;
                            <br/>
                            &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;##
                            ## &nbsp;## &nbsp;## &nbsp;## &nbsp; ## &nbsp; &nbsp; &nbsp;##### ## &nbsp; ##
                            ## &nbsp;## &nbsp;## &nbsp; ## ## # ##
                            ## &nbsp;## &nbsp;## &nbsp;### &nbsp; &nbsp;## &nbsp;## &nbsp; &nbsp; ## &nbsp; ## &nbsp; &nbsp; ## &nbsp;## &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            <br/>
                            &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;##
                            ## &nbsp;###### &nbsp;###### &nbsp; &nbsp; &nbsp;## &nbsp;##
                            ###### &nbsp;###### &nbsp;## &nbsp; ## ## # ## ##### &nbsp; ## #
                            ## &nbsp; &nbsp;###### &nbsp; &nbsp; &nbsp;###### &nbsp;##### &nbsp;## &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            <br/>
                            &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; ####### ## &nbsp; ##
                            ## &nbsp; &nbsp; &nbsp; &nbsp; ## &nbsp; ## ## &nbsp; &nbsp; &nbsp;## &nbsp; ## &nbsp;######
                            ## # ##
                            ## &nbsp;## &nbsp;### &nbsp;## &nbsp; &nbsp;## &nbsp; ## &nbsp; &nbsp; &nbsp; &nbsp; ##
                            ## &nbsp;## &nbsp;## &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<br/>
                            &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; ## &nbsp; ##
                            ###### &nbsp; ##### &nbsp; &nbsp; &nbsp;##### &nbsp; ##### &nbsp;###### &nbsp; &nbsp; &nbsp; ##
                            ####### ## &nbsp; ##
                            ## &nbsp; ## &nbsp; &nbsp;###### &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;## &nbsp;###### &nbsp;##### &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            <br/>
                            &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ##### &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            <br/>

                        </p>
                    </TimelineLink>
                    <p class={`${style['timeline__date--' + site]}`}>
                        Создан первый публичный интернет-сайт в России sovam.ru</p>
                    <p class={`${style['timeline__date--' + site]}`}>
                        <TimelineLink site={site} content="episode-1-moshkov">Максимом Мошковым</TimelineLink> создана
                        первая русскоязычная библиотека в интернете – сайт lib.ru</p>

                    <span class={`${style['timeline__year--' + site]}`}>
                        1995</span>
                    <p class={`${style['timeline__date--' + site]}`}>
                        <TimelineLink site={site} content="episode-1-lebedev">Артемий Лебедев</TimelineLink> открывает
                        студию WebDesign</p>
                    <p class={`${style['timeline__date--' + site]}`}>
                        <TimelineLink site={site} content="episode-1-verner">Дмитрий Вернер</TimelineLink> cоздает сайт
                        Anekdot.ru</p>
                    <span class={`${style['timeline__year--' + site]}`}>1996</span>
                    <p class={`${style['timeline__date--' + site]}`}>
                        Открылась компания <TimelineLink site={site}
                                                         video="episode-1-cityline">CityLine</TimelineLink> – первый
                        крупный интернет-провайдер.
                        Создатели: <TimelineLink site={site} content="episode-1-zaharov">Емельян Захаров</TimelineLink>,
                        <TimelineLink site={site} content="episode-1-kudryavtzev">Демьян Кудрявцев</TimelineLink>,
                        <TimelineLink site={site} content="episode-1-shuppe">Егор Шуппе.</TimelineLink></p>
                    <TimelineLink site={site} video={'episode-1-nedostatok-contenta'}>
                        <p className={`${style['timeline__outstanding--' + site]}`}>
                            <br/>
                            &nbsp;## &nbsp; ## &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            <br/>
                            &nbsp;## &nbsp; ## &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; #### &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;
                            <br/>
                            &nbsp;## &nbsp; ## &nbsp;##### &nbsp; &nbsp; &nbsp; ## &nbsp;##### &nbsp; ##### &nbsp;###### &nbsp; #### &nbsp; ###### &nbsp; ##### &nbsp;## &nbsp; ## &nbsp; &nbsp;## &nbsp; ## &nbsp;##### &nbsp;## &nbsp; ##
                            ###### &nbsp; ##### &nbsp;## &nbsp; ## ###### &nbsp; #### &nbsp;&nbsp;<br/>
                            &nbsp;####### ## &nbsp; ## &nbsp; ##### ## &nbsp; ##
                            ## &nbsp; &nbsp; &nbsp; &nbsp;## &nbsp; &nbsp; &nbsp; &nbsp;## &nbsp; &nbsp;## &nbsp; &nbsp;## &nbsp; ##
                            ## &nbsp;## &nbsp; &nbsp; ## &nbsp;## &nbsp;## &nbsp; ##
                            ## &nbsp; ## &nbsp; ## &nbsp; &nbsp;## &nbsp; ##
                            ## &nbsp; ## &nbsp; ## &nbsp; &nbsp; &nbsp; &nbsp;## &nbsp;<br/>
                            &nbsp;## &nbsp; ## ###### &nbsp; ## &nbsp;## ## &nbsp; ##
                            ## &nbsp; &nbsp; &nbsp; &nbsp;## &nbsp; &nbsp; ##### &nbsp; &nbsp;## &nbsp; &nbsp;## &nbsp; ##
                            ##### &nbsp; &nbsp; &nbsp;##### &nbsp; ## &nbsp; ##
                            ####### &nbsp; ## &nbsp; &nbsp;###### &nbsp;####### &nbsp; ## &nbsp; &nbsp; ##### &nbsp;
                            <br/>
                            &nbsp;## &nbsp; ## ## &nbsp; &nbsp; &nbsp;## &nbsp; ## ## &nbsp; ##
                            ## &nbsp; &nbsp; &nbsp; &nbsp;## &nbsp; &nbsp;## &nbsp;## &nbsp; &nbsp;## &nbsp; &nbsp;## &nbsp; ##
                            ## &nbsp;## &nbsp; &nbsp; ## &nbsp;## &nbsp;## &nbsp; ##
                            ## &nbsp; ## &nbsp; ## &nbsp; &nbsp;## &nbsp; &nbsp; &nbsp;## &nbsp; ## &nbsp; ## &nbsp; &nbsp;## &nbsp;## &nbsp;
                            <br/>
                            &nbsp;## &nbsp; ## &nbsp;##### &nbsp; ##### &nbsp; ##### &nbsp; ##### &nbsp; &nbsp;## &nbsp; &nbsp; ###### &nbsp; ## &nbsp; &nbsp; ##### &nbsp;## &nbsp; ## &nbsp; &nbsp;## &nbsp; ## &nbsp;##### &nbsp;## &nbsp; ## &nbsp; ## &nbsp; &nbsp; ##### &nbsp;## &nbsp; ## &nbsp; ## &nbsp; &nbsp; ######&nbsp;
                            <br/>
                            &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            <br/>

                        </p>
                    </TimelineLink>
                    <p class={`${style['timeline__date--' + site]}`}>
                        Появился блог <TimelineLink site={site} content="episode-1-nosik">Антона
                        Носика</TimelineLink> "Вечерний интернет"</p>
                    <p class={`${style['timeline__date--' + site]}`}>
                        Основан Zhurnal.ru</p>
                    <span className={`${style['timeline__year--' + site]}`}>
                        1998</span>
                    <p className={`${style['timeline__date--' + site]}`}>
                        Прошел первый конкурс сетевой русской литературы "Арт-Тенета". Один из ярких победителей –
                        писатель <TimelineLink site={site} content="episode-1-shiryanov">
                        Баян Ширянов</TimelineLink></p>
                    <p class={`${style['timeline__date--' + site]}`}>
                        <TimelineLink site={site} content="episode-1-itzkovich">Дмитрий
                            Ицкович</TimelineLink> и <TimelineLink site={site} content="episode-1-kolerov">Модест
                        Колеров</TimelineLink> основали Polit.ru</p>
                    <p class={`${style['timeline__date--' + site]}`}>
                            <span className={`${style['timeline__year--' + site]}`}>
                        1999</span>
                        <TimelineLink site={site} content="episode-1-revazov">Арсен Ревазов</TimelineLink> создал
                        рекламное сетевое агентство IMHO</p>
                    <a class={`${style['timeline__button']} ${style['timeline__button--' + site]}`}
                       onClick={() => props.handleSiteChange(site + 1, false, props.loadedImages)}>
                        В следующий эпизод (2) >>>
                    </a>
                </>
            }
            {
                props.site === 2 &&
                <>
                    <div className={`${style['timeline__episode-name']} ${style['timeline__episode-name--' + site]}`}>
                        ХОЛИВАР
                    </div>
                    <ReturnButton site={site} siteStyle={style} handleSiteChange={props.handleSiteChange}
                                  loadedImages={props.loadedImages}/>

                    <span className={`${style['timeline__year--' + site]}`}>
                        1996</span>

                    <p className={`${style['timeline__date--' + site]}`}>создан ФЭП (Фонд эффективной политики)
                        – организация, занимающаяся политическими кампаниями и интернет-проектами. Соучредитель и
                        директор – <TimelineLink site={site} content="episode-2-pavlovsky">
                            Глеб Павловский</TimelineLink>.
                        Среди проектов ФЭП: Vesti.ru, Lenta.ru,
                        главным редактором которых был <TimelineLink site={site} content="episode-1-nosik">Антон
                            Носик</TimelineLink>.</p>

                    <TimelineLink site={site} video={'episode-2-my-nauchili'}>
                        <p className={`${style['timeline__outstanding--' + site]}`}>
                            Мы научили интернет ругаться матом
                        </p>
                    </TimelineLink>

                    <span className={`${style['timeline__year--' + site]}`}>
                        1998</span>
                    <p className={`${style['timeline__date--' + site]}`}>создан сайт контркультуры Фак.ру. Создатели:
                        Егор Лавров
                        (<TimelineLink site={site} content="episode-2-lavrov">Скелетрон</TimelineLink>), Константин
                        Рыков (<TimelineLink site={site} content="episode-2-rykov">Форис</TimelineLink>),
                        Дмитрий Белинский (<TimelineLink site={site} content="episode-2-belinsky">Линкси</TimelineLink>)
                    </p>
                    <span className={`${style['timeline__year--' + site]}`}>
                        1999</span>
                    <p className={`${style['timeline__date--' + site]}`}>
                        Владимир Путин встретился с "представителями интернет-сообщества", чтобы узнать их "пожелания в
                        работе с властью"</p>

                    <TimelineLink site={site} video={'episode-2-nosik-putinu'}>
                        <p className={`${style['timeline__outstanding--' + site]}`}>
                            Антон Носик Владимиру Путину: "А вы можете запретить в России на заборах писать слово
                            "х**"?"
                        </p>
                    </TimelineLink>

                    <span className={`${style['timeline__year--' + site]}`}>
                        2000</span>
                    <p className={`${style['timeline__date--' + site]}`}>создатели Фак.ру открывают компанию "Эволюция
                        развлечений",
                        объединившую более десяти порносайтов и сайтов, предлагающих "знакомства".</p>

                    <span className={`${style['timeline__year--' + site]}`}>
                        2001</span>

                    <p className={`${style['timeline__date--' + site]}`}>первая онлайн-конференция президента России</p>

                    <p className={`${style['timeline__date--' + site]}`}><TimelineLink site={site}
                                                                                       content="episode-2-eremin">Степан
                        Еремин</TimelineLink> создал сайт Padonki.org</p>

                    <a className={`${style['timeline__button']} ${style['timeline__button--' + site]}`}
                       onClick={() => props.handleSiteChange(site + 1, false, props.loadedImages)}>
                        В следующий эпизод (3) >>>
                    </a>
                </>
            }

            {
                props.site === 3 &&
                <>
                    <div className={`${style['timeline__episode-name']} ${style['timeline__episode-name--' + site]}`}>
                        ХОЛИВАР
                    </div>
                    <ReturnButton site={site} siteStyle={style} handleSiteChange={props.handleSiteChange}
                                  loadedImages={props.loadedImages}/>

                    <TimelineLink site={site} video={'episode-3-lekala'}>
                        <p className={`${style['timeline__outstanding--' + site]}`}>
                            Мы все делали по аналогам американских лекал
                        </p>
                    </TimelineLink>

                    <span className={`${style['timeline__year--' + site]}`}>
                        1996</span>

                    <p className={`${style['timeline__date--' + site]}`}><TimelineLink site={site}
                                                                                       content="episode-3-krukov">Дмитрий
                        Крюков</TimelineLink> и <TimelineLink site={site} content="episode-3-lysakov">Сергей
                        Лысаков</TimelineLink> создали Rambler.</p>

                    <span className={`${style['timeline__year--' + site]}`}>
                        1997</span>

                    <p className={`${style['timeline__date--' + site]}`}><TimelineLink site={site}
                                                                                       content="episode-3-segalovich">Илья
                        Сегалович</TimelineLink> и <TimelineLink site={site} content="episode-3-volozh">Аркадий
                        Волож</TimelineLink> создают Yandex.</p>

                    <span className={`${style['timeline__year--' + site]}`}>
                        1998</span>

                    <p className={`${style['timeline__date--' + site]}`}>создан сайт Ozon.ru, первый интернет-магазин с
                        системой оплаты электронными картам.</p>

                    <span className={`${style['timeline__year--' + site]}`}>
                        1999</span>

                    <p className={`${style['timeline__date--' + site]}`}>создан первый интернет-аукцион в России
                        "Молоток.ру".</p>
                    <span className={`${style['timeline__year--' + site]}`}>
                        2000</span>

                    <p className={`${style['timeline__date--' + site]}`}>10 марта – лопнул "пузырь доткомов" – падение
                        индексов NASDAQ ряда крупных интернет-компаний, многие из которых разорились.</p>

                    <TimelineLink site={site} video={'episode-3-dotkom'}>
                        <p className={`${style['timeline__outstanding--' + site]}`}>
                            В России пузырь надуться еще не успел, а на Западе уже лопнул
                        </p>
                    </TimelineLink>

                    <p className={`${style['timeline__date--' + site]}`}>
                        Yandex стал первым сайтом, <TimelineLink site={site}
                                                                 video="episode-3-yandex">запустившим рекламу на
                        телевидении</TimelineLink>.</p>


                    <span className={`${style['timeline__year--' + site]}`}>
                        2001</span>

                    <p className={`${style['timeline__date--' + site]}`}>Yandex запускает систему контекстной
                        рекламы.</p>

                    <span className={`${style['timeline__year--' + site]}`}>
                        2002</span>

                    <p className={`${style['timeline__date--' + site]}`}>Rambler продан инвестиционному
                        банкиру <TimelineLink site={site} content="episode-3-radzinsky">Олегу Радзинскому</TimelineLink>.
                    </p>

                    <span className={`${style['timeline__year--' + site]}`}>
                        2005</span>

                    <p className={`${style['timeline__date--' + site]}`}>Rambler стал первой российской
                        интернет-компанией, вышедшей на IPO.</p>

                    <span className={`${style['timeline__year--' + site]}`}>
                        2006</span>

                    <p className={`${style['timeline__date--' + site]}`}>Rambler продан компании "ПрофМедиа",
                        принадлежащей Владимиру Потанину.</p>

                    <span className={`${style['timeline__year--' + site]}`}>
                        2011</span>

                    <p className={`${style['timeline__date--' + site]}`}>Yandex вышел на IPO.</p>


                    <a className={`${style['timeline__button']} ${style['timeline__button--' + site]}`}
                       onClick={() => props.handleSiteChange(site + 1, false, props.loadedImages)}>
                        В следующий эпизод (4) >>>
                    </a>
                </>
            }

            {
                props.site === 4 &&
                <>
                    <div className={`${style['timeline__episode-name']} ${style['timeline__episode-name--' + site]}`}>
                        ХОЛИВАР
                    </div>
                    <ReturnButton site={site} siteStyle={style} handleSiteChange={props.handleSiteChange}
                                  loadedImages={props.loadedImages}/>


                    <p className={`${style['timeline__date--' + site]}`}>
                        <TimelineLink site={site} content="episode-4-krivenkov">Алексей Кривенков</TimelineLink> написал скрипт Mail.ru
                    <span className={`${style['timeline__year--' + site]}`}>
                        1997 год</span></p>

                    <p className={`${style['timeline__date--' + site]}`}>
                        Кривенков с партнерами создают компанию Port.ru
                        <span className={`${style['timeline__year--' + site]}`}>
                        1998 год</span></p>

                    <p className={`${style['timeline__date--' + site]} ${style['timeline__date--wcomment']}`}>
                        <ul><li>Port.ru привлекла первые западные инвестиции в Mail.ru</li>
                            <li><TimelineLink site={site} content="episode-4-milner">Юрий Мильнер</TimelineLink> создает компанию NetBridge и делает первые инвестиции в Рунет: сайты Fomenko.ru и List.ru Германа Клименко</li></ul>
                        <span className={`${style['timeline__year--' + site]}`}>
                        1999 год</span></p>

                    <TimelineLink site={site} video={'episode-4-bashnya'}>
                        <p className={`${style['timeline__outstanding--' + site]}`}>
                            Дети спят, а я завоевываю башню. <span>Смотри тут!</span>
                        </p>
                    </TimelineLink>

                    <p className={`${style['timeline__date--' + site]}`}>
                        слияние компаний Port.ru и NetBridge. Новое название компании – Mail.ru
                        <span className={`${style['timeline__year--' + site]}`}>
                        2000 год</span></p>

                    <p className={`${style['timeline__date--' + site]}`}>
                        создана первая российская браузерная онлайн-игра "Бойцовский клуб"
                        <span className={`${style['timeline__year--' + site]}`}>
                        2001 год</span></p>


                    <p className={`${style['timeline__date--' + site]}`}>
                        <TimelineLink site={site} content="episode-4-zhukov">Сергей Жуков</TimelineLink> и <TimelineLink site={site} content="episode-4-matzanuk">Игорь Мацанюк</TimelineLink> создают компанию It Territory. Первый успех компании – онлайн-игра "Территория"
                        <span className={`${style['timeline__year--' + site]}`}>
                        2004 год</span></p>

                    <p className={`${style['timeline__date--' + site]}`}>
                        <ul><li><TimelineLink site={site} content="episode-4-popkov">Альберт Попков</TimelineLink> создал сайт Odnoklassniki.ru</li>
                            <li>создан сайт "ВКонтакте". Среди основателей – <TimelineLink site={site} content="episode-4-durov">Павел Дуров</TimelineLink> и <TimelineLink site={site} content="episode-4-leviev">Лев Левиев</TimelineLink></li></ul>
                        <span className={`${style['timeline__year--' + site]}`}>
                        2006 год</span></p>


                    <p className={`${style['timeline__date--' + site]} ${style['timeline__date--wcomment']}`}>
                        <ul><li>Mail.ru объединяется с компанией It Territory</li>
                            <li>Юрий Мильнер покупает долю в "Одноклассниках" и "ВКонтакте"</li></ul>
                        <span className={`${style['timeline__year--' + site]}`}>
                        2007 год</span></p>

                    <TimelineLink site={site} video={'episode-4-sekta'}>
                        <p className={`${style['timeline__outstanding--' + site]} ${style['timeline__outstanding--lobushkin']}`}>
                            Это была секта! <span>Смотри тут...</span>
                        </p>
                    </TimelineLink>

                    <p className={`${style['timeline__date--' + site]}`}>
                        <ul><li>на создателя "Одноклассников" подают в суд за плагиат. У компании меняется руководитель</li>
                            <li>мировой финансовый кризис</li>
                            <li><TimelineLink site={site} content="episode-4-usmanov">Алишер Усманов</TimelineLink> инвестирует в венчурный фонд Юрия Мильнера DST Global</li>
                            </ul>

                        <span className={`${style['timeline__year--' + site]}`}>
                        2008 год</span></p>

                    <p className={`${style['timeline__date--' + site]}`}>
                        <ul><li>DST Global покупает долю компании Facebook</li>
                            <li>создана компания Game Insight Игоря Мацанюка</li></ul>
                        <span className={`${style['timeline__year--' + site]}`}>
                        2009 год</span></p>

                    <p className={`${style['timeline__date--' + site]}`}>
                        Mail.ru Group провела первое публичное размещение на Лондонской фондовой бирже. Юрий Мильнер продал свою долю в компании и переехал в США
                        <span className={`${style['timeline__year--' + site]}`}>
                        2010 год</span>
                    <br />
                    <br />
                        <img src='https://docs.rferl.org/infographics/2019/2019_07/2019_07_HolyWar/images/verni_stenu--4.png'/>
                        </p>

                    <p className={`${style['timeline__date--' + site]} ${style['timeline__date--wcomment']}`}>
                        <ul><li>Facebook выходит на IPO</li>
                            <li>Мильнер и Усманов продали свою долю в Facebook</li>
                            <li>Юрием Мильнером учреждена премия "Прорыв" за достижения в науке</li>
                            <li>Павел Дуров дарит $1 млн Википедии</li></ul>
                        <span className={`${style['timeline__year--' + site]}`}>
                        2012 год</span></p>

                    <TimelineLink site={site} video={'episode-4-sechin'}>
                        <p className={`${style['timeline__outstanding--' + site]} ${style['timeline__outstanding--kononov']}`}>
                            Во всем этом &#8593; видели почерк Сечина. <span>Подробнее здесь</span>
                        </p>
                    </TimelineLink>

                    <p className={`${style['timeline__date--' + site]}`}>
                        на Павла Дурова заводят уголовное дело
                        <span className={`${style['timeline__year--' + site]}`}>
                        2013 год</span></p>

                    <p className={`${style['timeline__date--' + site]}`}>
                        Павел Дуров запускает Telegram
                        <span className={`${style['timeline__year--' + site]}`}>
                        2014 год</span></p>

                    <p className={`${style['timeline__date--' + site]}`}>
                        сын генерального директора ВГТРК <TimelineLink site={site} content="episode-4-dobrodeev">Борис Добродеев</TimelineLink> занимает должность генерального директора Mail.ru Group
                        <span className={`${style['timeline__year--' + site]}`}>
                        2015 год</span></p>

                    <p className={`${style['timeline__date--' + site]}`}>
                        Юрий Мильнер совместно по Стивеном Хокингом реализовали проект Starshot по разработке концепции сверхскоростных космических кораблей
                        <span className={`${style['timeline__year--' + site]}`}>
                        2016 год</span></p>

                    <a className={`${style['timeline__button']} ${style['timeline__button--' + site]}`}
                       onClick={() => props.handleSiteChange(site + 1, false, props.loadedImages)}>
                        В следующий эпизод (5) >>>
                    </a>
                </>
            }

            {
                props.site === 5 &&
                <>
                <div className={`${style['timeline__episode-name']} ${style['timeline__episode-name--' + site]}`}>
                    ХОЛИВАР
                </div>
                    <ReturnButton site={site} siteStyle={style} handleSiteChange={props.handleSiteChange}
                        loadedImages={props.loadedImages} />
                    <p className={`${style['timeline__date--' + site]}`}>
                        <div className={`${style['timeline__user--' + site]}`}>
                        ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        <span className={`${style['timeline__year--' + site]}`}>1999</span>
                        </div>
                        <TimelineLink site={site} content="episode-5-fitzpatrick">Брэд Фицпатрик</TimelineLink> создал
                        LiveJournal</p>
                        <div className={`${style['timeline__troll--' + site]}`}>
                        <div className={`${style['timeline__troll-inner--' + site]}`}>
                            <h6>Anonymous</h6>
                            Hello, world
                        </div>
                    </div>
                    <div className={`${style['timeline__troll--' + site]}`}>
                        <div className={`${style['timeline__troll-inner--' + site]}`}>
                            <h6>Неизвестный Пользователь</h6>
                            И даже по-русски можно? Ну вааще
                        </div>
                    </div>
                    <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                    ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        <span className={`${style['timeline__year--' + site]}`}>2001</span>
                        </div>Первый пост в
                        ЖЖ <TimelineLink site={site} content="episode-5-potupchik">Кристины Потупчик</TimelineLink></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                            ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        </div>
                        "Если бы не было ЖЖ, я вообще не смог бы политикой заниматься". <br /><br />
                        <video poster='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/05-navalny-poster.jpg'
                            controls='true' style={{width: '100%', maxWidth: '100%', maxHeight: '280px', backgroundColor: '#000'}}>
                            <source src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/05-navalny.mp4' type='video/mp4'/>
                        </video></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                    ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        <span className={`${style['timeline__year--' + site]}`}>2005</span>
                        </div>
                        <TimelineLink site={site} content="episode-5-navalny">Алексей Навальный</TimelineLink> создал блог в ЖЖ</p>

                    <div className={`${style['timeline__troll--' + site]}`}>
                        <div className={`${style['timeline__troll-inner--' + site]}`}>
                            <h6>Неизвестный Пользователь 1</h6>
                            Вперед!
                        </div>
                    </div>
                    <div className={`${style['timeline__troll--' + site]}`}>
                        <div className={`${style['timeline__troll-inner--' + site]}`}>
                            <h6>Неизвестный Пользователь 2</h6>
                            Поддерживаю! Денег не дам!
                        </div>
                    </div>
                        <p className={`${style['timeline__date--' + site]}`}>
                        <TimelineLink site={site} content="episode-5-surkov">Владислав Сурков</TimelineLink> и <TimelineLink site={site} content="episode-5-yakemenko">Василий Якеменко</TimelineLink> создали
                        прокремлевское движение "Наши"</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                        первый пост Кристины Потупчик в ЖЖ в качестве комиссара "Наших"</p>
                    <div className={`${style['timeline__troll--' + site]}`}>
                        <div className={`${style['timeline__troll-inner--' + site]}`}>
                            <h6>Неизвестный Пользователь 1</h6>
                            Большая политика  - непростая вещь.
                        </div>
                    </div>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                    ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        <span className={`${style['timeline__year--' + site]}`}>2007</span>
                        </div>
                        Фицпатрик впервые приезжает в Россию</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                            ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        <span className={`${style['timeline__year--' + site]}`}>2010</span>
                        </div>
                        В ЖЖ появилось "Общество синих ведерок" – неформальное сообщество блогеров, борющихся с "мигалками" на дорогах</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                        Livejournal выкупает компания SUP 
                        Media <TimelineLink site={site} content="episode-5-mamuta">Александра Мамута</TimelineLink></p>

                    <p className={`${style['timeline__date--' + site]}`}>
                       <img src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/timeline__date__unavailable--5.png'/>
                    </p>

                        <p className={`${style['timeline__date--' + site]}`}>
                        пожары в центральной полосе России</p>

                        <p className={`${style['timeline__date--' + site]}`}>
                        пользователи ЖЖ объединились для помощи пострадавшим от
                        пожаров. <TimelineLink site={site} content="episode-5-asmolov">Григорий Асмолов</TimelineLink> создает
                        "Карту помощи" – первый успешный краудсорсинговый проект в России</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                            ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        </div>
                        Появились вопросы: "А зачем мы платим налоги? А зачем мы сотрудничаем с государством, если мы можем решать все вопросы сами?"<br /><br />
                        <video poster='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/05-netsociety-poster.jpg'
                            controls='true' style={{width: '100%', maxWidth: '100%', maxHeight: '280px', backgroundColor: '#000'}}>
                            <source src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/05-netsociety.mp4' type='video/mp4'/>
                        </video></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                        Навальный запустил проект "РосПил" – краудсорсинговый проект по выявлению злоупотреблений в госзакупках</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                            ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        <span className={`${style['timeline__year--' + site]}`}>2011</span>
                        </div>
                        Кристина Потупчик начинает создавать сеть ЖЖ "нашистов" и заказывать проплаченные тексты у топ-блогеров</p>

                    <div className={`${style['timeline__troll--' + site]}`}>
                        <div className={`${style['timeline__troll-inner--' + site]}`}>
                            <h6>Неизвестный Пользователь 1</h6>
                            Да шо вы говорите!
                        </div>
                    </div>

                        <p className={`${style['timeline__date--' + site]}`}>
                        <TimelineLink site={site} content="episode-5-malofeev">Константин Малофеев</TimelineLink> создал
                        Лигу безопасного интернета. Среди проектов Лиги –
                        "Кибердружина" <TimelineLink site={site} content="episode-5-pastshenko">Григория Пащенко</TimelineLink></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                        фальсификации на выборах в пользу "Единой России". Сеть заполонили видео- и фотоподтверждения вбросов</p>

                    <p className={`${style['timeline__date--' + site]}`}>
                        <img src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/timeline__date__unavailable--5.png'/>
                    </p>

                        <p className={`${style['timeline__date--' + site]}`}>
                        <TimelineLink site={site} content="episode-5-okhotin">Григорий Охотин</TimelineLink> создает
                        медиапроект "ОВД-Инфо", помогающий незаконно задержанным и политическим заключенным</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                            ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        <span className={`${style['timeline__year--' + site]}`}>2012</span>
                        </div>
                        митинг на Болотной площади</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                        заработал "бешеный принтер" по запретительным законам в Рунете</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                            ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        </div>
                        "Эта дума получила полномочия хунвейбинов в Китае. Им разрешили громить".<br /><br />
                        <video poster='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/05-nosik-poster.jpg'
                            controls='true' style={{width: '100%', maxWidth: '100%', maxHeight: '280px', backgroundColor: '#000'}}>
                            <source src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/05-Nosik.mp4' type='video/mp4'/>
                        </video></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                        Лигой безопасного интернета создан проект закона "О защите детей от информации", благодаря которому появился Единый реестр запрещенных сайтов</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                        забастовка русской Википедии против закона "О защите детей от информации". Акцию поддержали "Живой Журнал", "Вконтакте", "Яндекс" и "Луркморье"</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                        создан проект
                        "РосКомСвобода" <TimelineLink site={site} content="episode-5-kozlyuk">Артема Козлюка</TimelineLink></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                            ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        <span className={`${style['timeline__year--' + site]}`}>2013</span>
                        </div>
                        вышло расследование "Новой газеты" о "фабрике троллей" – "Агентстве интернет-исследований"</p>
                    <div className={`${style['timeline__troll--' + site]}`}>
                        <div className={`${style['timeline__troll-inner--' + site]}`}>
                            <h6>Неизвестный Пользователь 2</h6>
                            Ну да, людям-то заняться больше нечем, ЛОЛ)))))
                        </div>
                    </div>
                        <p className={`${style['timeline__date--' + site]}`}>
                        Советом Федерации принят закон о блокировке экстремистских сайтов. Автор закона
                        – <TimelineLink site={site} content="episode-5-logovoy">Андрей Луговой</TimelineLink></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                            ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        <span className={`${style['timeline__year--' + site]}`}>2014</span>
                        </div>
                        первые жертвы закона Лугового. Роскомнадзор заблокировал Грани.ру, Каспаров.ру, "Ежедневный журнал" и два блога Алексея Навального</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                        создана "Фабрика-медиа" – медиахолдинг новостных сайтов с прокремлевскими новостями. Самый популярный ресурс – Федеральное агентство новостей
                        (РИА ФАН) <TimelineLink site={site} content="episode-5-zubareva">Евгения Зубарева</TimelineLink></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                            ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        <span className={`${style['timeline__year--' + site]}`}>24 декабря 20??</span>
                        </div>
                        против <TimelineLink site={site} content="episode-5-malofeeva">Константина Малофеева,</TimelineLink> лидеров
                        так называемых "ЛНР" и "ДНР", "Ночных волков" и Натальи Поклонской введены
                        санкции США</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                            ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        </div>
                        "Когда убили Немцова, моя коллега [по "фабрике троллей"] расстроилась чуть ли не до слез. А потом села писать новость "Собаке – собачья смерть".<br /><br />
                        <video poster='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/05-fabrika-poster.jpg'
                            controls='true' style={{width: '100%', maxWidth: '100%', maxHeight: '280px', backgroundColor: '#000'}}>
                            <source src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/video/05-fabrika.mp4' type='video/mp4'/>
                        </video></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__user--' + site]}`}>
                            ХОЛИВАР. ИСТОРИЯ РУНЕТА
                        <span className={`${style['timeline__year--' + site]}`}>1 ноября 2019</span>
                        </div>
                        вступил в силу закон о суверенном интернете, позволяющий внедрить новые системы фильтрации и изолировать
                        Рунет от глобальной Сети (<TimelineLink site={site} content="episode-5-logovoy">Луговой,</TimelineLink> <TimelineLink site={site} content="episode-5-klishas">Клишас,</TimelineLink> Боковая)</p>



                    <a className={`${style['timeline__button']} ${style['timeline__button--' + site]}`}
                        onClick={() => props.handleSiteChange(site + 1, false, props.loadedImages)}>
                        В следующий эпизод (6) >>>
                    </a>
                </>
            }

            {
                props.site === 6 &&
                <>
                <div className={`${style['timeline__top--' + site]}`}>
                <div className={`${style['timeline__episode-name']} ${style['timeline__episode-name--' + site]}`}>
                    ХОЛИВАР
                </div>
                    <Clock site={site}></Clock>
                </div>

                <div className={`${style['timeline__inner--' + site]}`}>

                <ReturnButton site={site} siteStyle={style} handleSiteChange={props.handleSiteChange}
                        loadedImages={props.loadedImages} />

                <div className={`${style['timeline__grid--' + site]} ${style['timeline__grid-first--' + site]}`}>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Новости</span><span className={`${style['timeline__grey--' + site]}`}> - 2012</span>
                        </div>
                        аудитория "Яндекса" превысила аудиторию "Первого канала"</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Новости</span><span className={`${style['timeline__grey--' + site]}`}> - 1 ноября 2012</span>
                        </div>
                        создан Единый реестр запрещенных сайтов, среди первых заблокированных ресурсов –
                        "Луркоморье" <TimelineLink site={site} content="episode-6-khomaka">Давида Хомака</TimelineLink></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Мемас</span>
                        </div>
                        <br />
                        <img src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/2012.jpg'/>
                        </p>

                        <p className={`${style['timeline__outstanding--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Видос</span>
                        </div>
                            <TimelineLink site={site} video={'episode-6-lurk'}>
                            "Они фальсифицировали отчетность. Им нужно было запретить в новом квартале больше, чем в предыдущем".
                        </TimelineLink></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Новости</span><span className={`${style['timeline__grey--' + site]}`}> - 2 июля 2013</span>
                        </div>
                        вступил в силу закон о "пропаганде нетрадиционных сексуальных отношений среди несовершеннолетних".</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Новости</span><span className={`${style['timeline__grey--' + site]}`}> - 27 июля 2013</span>
                        </div>
                        от рака мозга умер основатель
                        "Яндекса" <TimelineLink site={site} content="episode-6-segalovich">Илья Сегалович</TimelineLink></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Новости</span><span className={`${style['timeline__grey--' + site]}`}> - 27 июля 2013</span>
                        </div>
                        решением <TimelineLink site={site} content="episode-6-mamuta">Александра Мамута</TimelineLink> уволена
                        главный редактор Lenta.ru <TimelineLink site={site} content="episode-6-timchenko">Галина Тимченко</TimelineLink></p>

                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Новости</span><span className={`${style['timeline__grey--' + site]}`}> - 13 марта 2014</span>
                        </div>
                        в России заблокированы "Грани.Ru", "Каспаров.Ru", ej.ru и 
                        блог <TimelineLink site={site} content="episode-6-navalny">Алексея Навального</TimelineLink></p>
                        
                        </div>
                        <div className={`${style['timeline__grid--' + site]}`}>

                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Мемас</span>
                        </div>
                        <br />
                        <img src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/2014.jpg'/>
                        </p>
                        <p className={`${style['timeline__outstanding--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Видос</span>
                        </div>
                            <TimelineLink site={site} video={'episode-6-putin'}>
                            Путин: "Интернет – проект ЦРУ".
                        </TimelineLink></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Новости</span><span className={`${style['timeline__grey--' + site]}`}> - 20 октября 2014</span>
                        </div>
                        в Риге начинает работу сайт Meduza.ru.</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Новости</span><span className={`${style['timeline__grey--' + site]}`}> - 2015</span>
                        </div>
                        блокировка проекта 
                        "Дети-404" <TimelineLink site={site} content="episode-6-klimovoy">Лены Климовой</TimelineLink></p>
                        <p className={`${style['timeline__outstanding--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Видос</span>
                        </div>
                            <TimelineLink site={site} video={'episode-6-aerosol'}>
                            "Пора уже включить наш нормальный гомофобный аэрозоль".
                        </TimelineLink></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Новости</span><span className={`${style['timeline__grey--' + site]}`}> - 23 июня 2016</span>
                        </div>
                        Путин подписал закон, приравнивающий новостные агрегаторы к СМИ.</p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Новости</span><span className={`${style['timeline__grey--' + site]}`}> - 2016</span>
                        </div>
                        <TimelineLink site={site} content="episode-6-klimenko">Герман Клименко</TimelineLink><span> стал
                            советником президента России по вопросам развития интернета.</span></p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Мемас</span>
                        </div>
                        Денег нет, но вы держитесь!
                        <br /><br />
                        <img src='https://docs.rferl.org/Infographics/2019/2019_07/2019_07_HolyWar/images/2016-deneg.jpg'/>
                        </p>
                        <p className={`${style['timeline__date--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Новости</span><span className={`${style['timeline__grey--' + site]}`}> - 2018</span>
                        </div>
                        более 500 человек осуждены по 282 статье (“Возбуждение ненависти либо вражды”).</p>
                        <p className={`${style['timeline__date--' + site]} ${style['timeline__date-last--' + site]}`}>
                    <div className={`${style['timeline__date-header--' + site]}`}>
                        <span className={`${style['timeline__pink--' + site]}`}>Новости</span><span className={`${style['timeline__grey--' + site]}`}> - 2019</span>
                        </div>
                        в Москве
                        арестован <TimelineLink site={site} content="episode-6-kalvi">Майкл Калви</TimelineLink><span>,
                            основатель фода"Беринг-Восток".</span></p>

                    <a className={`${style['timeline__button']} ${style['timeline__button--' + site]}`}
                        onClick={() => props.handleSiteChange(site + 1, false, props.loadedImages)}>
                        В следующий эпизод (7) >>>
                    </a>
                    </div>
                </div>
                </>
            }


            {
                props.site === 7 &&
                <>
                    <div className={`${style['timeline__episode-name']} ${style['timeline__episode-name--' + site]}`}>
                        ХОЛИВАР
                    </div>
                <ReturnButton site={site} siteStyle={style} handleSiteChange={props.handleSiteChange}
                        loadedImages={props.loadedImages} />

                    <p className={`${style['timeline__date--' + site]}`}>
                        <span className={`${style['timeline__year--' + site]}`}>
                        2005</span>
                        <div className={`${style['timeline__dot--' + site]}`}>
                        <Glitch enabled={boolRand()} blockedText={blockedInYourCountry}>
                            три бывших сотрудника PayPal из Калифорнии создают YouTube
                            </Glitch></div>
                        <div className={`${style['timeline__dot--' + site]}`}>
                                ????? ????????????????????????? ??????????????????? ?????????????
                            </div>
                        </p>
                    <p className={`${style['timeline__date--' + site]}`}>
                        <span className={`${style['timeline__year--' + site]}`}>
                        2006</span>
                        <div className={`${style['timeline__dot--' + site]}`}>
                        <Glitch enabled={boolRand()} blockedText={blockedInYourCountry}>
                            российские предприниматели из Орла создают Rutube
                            </Glitch></div>
                        <div className={`${style['timeline__dot--' + site]}`}>
                        <Glitch enabled={boolRand()} blockedText={blockedInYourCountry}>
                            Google покупает YouTube за 1,65 миллиарда долларов
                            </Glitch></div>
                        </p>
                    <p className={`${style['timeline__date--' + site]}`}>
                        <span className={`${style['timeline__year--' + site]}`}>
                        2007</span>
                        <div className={`${style['timeline__dot--' + site]}`}>
                        <Glitch enabled={boolRand()} blockedText={blockedInYourCountry}>
                            YouTube запустил русскую версию, открывшуюся клипом певца Петра Налича
                            </Glitch></div>
                        <div className={`${style['timeline__dot--' + site]}`}>
                        <Glitch enabled={boolRand()} blockedText={blockedInYourCountry}>первое видео на
                        ютуб-канале <TimelineLink site={site} content="episode-7-degtyarev">Юрия Дегтярева</TimelineLink> и <TimelineLink site={site} content="episode-7-nikel">Сэма Никеля</TimelineLink> My Duck's Vision
                        </Glitch>
                        </div>
                        </p>
                    <p className={`${style['timeline__date--' + site]}`}>
                        <span className={`${style['timeline__year--' + site]}`}>
                        2008</span>
                        <div className={`${style['timeline__dot--' + site]}`}>
                        <Glitch enabled={boolRand()} blockedText={blockedInYourCountry}>"Газпром-медиа" покупает Rutube
                        </Glitch></div>
                        </p>
                    <p className={`${style['timeline__date--' + site]}`}>
                        <span className={`${style['timeline__year--' + site]}`}>
                        2010</span>
                        <div className={`${style['timeline__dot--' + site]}`}>
                        <Glitch enabled={boolRand()} blockedText={blockedInYourCountry}>
                            первое видео <TimelineLink site={site} content="episode-7-zheludya">Ромы Желудя</TimelineLink> в
                            YouTube
                            </Glitch></div>
                        <div className={`${style['timeline__dot--' + site]}`}>
                        <Glitch enabled={boolRand()} blockedText={blockedInYourCountry}>
                            <TimelineLink site={site} content="episode-7-parfenov">Леонид Парфенов</TimelineLink> произнес
                        скандальную речь на премии им.Листьева, в которой назвал образ власти в СМИ "дорогим покойником,
                        о котором либо хорошо, либо ничего"
                        </Glitch></div>
                        </p>

                    <TimelineLink site={site} video={'episode-7-jelud'}>
                        <p className={`${style['timeline__outstanding--' + site]}`}>
                        <div className={`${style['timeline__outstanding-1--' + site]}`}>Ой!</div>
                        <div className={`${style['timeline__outstanding-2--' + site]}`}>Ошибка 404</div>
                        <div className={`${style['timeline__outstanding-3--' + site]}`}>Нажмите <span>тут,</span> чтобы все равно посмотреть</div>
                        "Меня огромное количество раз избивали на улице"
                        </p>
                    </TimelineLink>

                    <p className={`${style['timeline__date--' + site]}`}>
                        <span className={`${style['timeline__year--' + site]}`}>
                        2011</span>
                        <div className={`${style['timeline__dot--' + site]}`}>
                        <Glitch enabled={boolRand()} blockedText={blockedInYourCountry}>
                            Март 2011: <TimelineLink site={site} content="episode-5-yakemenko">Василий Якименко</TimelineLink> вместе
                        с авторами My Duck's Vision на деньги Кремля создает сообщество видеоблогеров "Спасибо, Ева!"
                        </Glitch></div>
                        <div className={`${style['timeline__dot--' + site]}`}>
                           ????????????? ????????? ???????????
                            </div>
                        </p>
                    <p className={`${style['timeline__date--' + site]}`}>
                        <span className={`${style['timeline__year--' + site]}`}>
                        2013</span>
                        <div className={`${style['timeline__dot--' + site]}`}>
                        <Glitch enabled={boolRand()} blockedText={blockedInYourCountry}>
                            хакеры из группировки "Анонимус" взломали
                        почту <TimelineLink site={site} content="episode-5-potupchik">Кристины Потупчик</TimelineLink>
                        </Glitch></div>
                        <div className={`${style['timeline__dot--' + site]}`}>
                        <Glitch enabled={boolRand()} blockedText={blockedInYourCountry}>
                        <TimelineLink site={site} content="episode-7-prusikin">Илья ("Ильич") Прусикин</TimelineLink>, <TimelineLink site={site} content="episode-7-usachev">Руслан Усачев</TimelineLink> и
                        другие ютуберы создают независимое сообщество видеоблогеров "КЛИККЛАК"
                        </Glitch></div>
                        </p>

                    <TimelineLink site={site} video={'episode-7-money'}>
                        <p className={`${style['timeline__outstanding--' + site]}`}>
                        <div className={`${style['timeline__outstanding-1--' + site]}`}>Ой!</div>
                        <div className={`${style['timeline__outstanding-2--' + site]}`}>Ошибка 404</div>
                        <div className={`${style['timeline__outstanding-3--' + site]}`}>Нажмите <span>тут,</span> чтобы все равно посмотреть</div>
                        "Это как смотреть порно, но все еще задаваться вопросом, откуда берутся дети".
                        </p>
                    </TimelineLink>

                    <p className={`${style['timeline__date--' + site]}`}>
                        <span className={`${style['timeline__year--' + site]}`}>
                        2017</span>
                        <div className={`${style['timeline__dot--' + site]}`}>
                        <Glitch enabled={boolRand()} blockedText={blockedInYourCountry}>
                            <TimelineLink site={site} content="episode-7-dud">Юрий Дудь</TimelineLink> запустил
                        шоу в YouTube "вДудь". После успеха шоу в YouTube пришли другие известные журналисты
                        </Glitch></div>
                        </p>

                    <p className={`${style['timeline__date--' + site]}`}>
                        <span className={`${style['timeline__year--' + site]}`}>
                        ????</span>
                        <div className={`${style['timeline__dot--' + site]}`}>
                            ??????? ???????????? ? ???? ???? ? ????????? ??????????? ???? ?????? ?? ????
                           </div>
                    </p>

                    <p className={`${style['timeline__date--' + site]}`}>
                        <span className={`${style['timeline__year--' + site]}`}>
                        2019</span>
                        <div className={`${style['timeline__dot--' + site]}`}>
                        <Glitch enabled={boolRand()} blockedText={blockedInYourCountry}>
                        10 августа: Видеоблогеры и музыканты <TimelineLink site={site} content="episode-7-poperechny">Данила Поперечный</TimelineLink>, "Ресторатор",
                        Эльдар Джахаров, <TimelineLink site={site} content="episode-7-icepeak">Ic3Peak</TimelineLink>, Face
                        и "Кровосток" выступают на митинге в Москве "За честные выборы!" 
                        </Glitch></div>
                        </p>
                    <TimelineLink site={site} video={'episode-7-meeting'}>
                        <p className={`${style['timeline__outstanding--' + site]}`}>
                            <div className={`${style['timeline__outstanding-1--' + site]}`}>Ой!</div>
                            <div className={`${style['timeline__outstanding-2--' + site]}`}>Ошибка 404</div>
                            <div className={`${style['timeline__outstanding-3--' + site]}`}>Нажмите <span>тут,</span> чтобы все равно посмотреть</div>
                            "Они шьют уголовные дела, они привозят ОМОН, закупают водометы... Скажите, мы боимся их?".
                        </p>
                    </TimelineLink>

                </>
            }
        </div>
    )
}

export default Timeline;
